import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {GameRunnerService} from "./game-runner.service";
import {reaction} from "mobx";
import {GameInfo} from "../games/game-info";
import {Check} from "@sparkware/app-utils";
import {IRunningGameBrowserTabController} from "./running-game-browser-tab-controller.interface";
import {NullableString} from "../../../common/types/nullable-types";
import {LocalStorageKeys} from "../storage/local-storage-keys";

export class RunningGameBrowserTabController implements IRunningGameBrowserTabController {
    constructor(private readonly gameRunner: GameRunnerService,
                private readonly services: IServiceFactoryExtended) {
        reaction(() => gameRunner.currentRunningGame,
            (runningGame) => {
            if(runningGame) {
                this._setActiveGame(runningGame.gameContext.gameInfo.gameType);
                this._activeGameInAnotherTabDetectionTimer = setInterval(this._detectActiveGameInAnotherTab, 1000);
            } else {
                clearTimeout(this._activeGameInAnotherTabDetectionTimer);
                this._onGameClosed();
            }
        },{fireImmediately:true});
    }

    private _activeGameInAnotherTabDetectionTimer: any  = null;

    private _detectActiveGameInAnotherTab = () => {
        if(this.isGameRunningInAnotherTab) {
            this.gameRunner.currentRunningGame.closeGame({
                shouldSuggestNextGame: false
            });
        }
    }

    get isGameRunningInAnotherTab(): boolean {
        if(!this.activeGame) {
            return false;
        }

        return this._currentBrowserTabId !== this._activeGameTabId;
    }

    private get _currentBrowserTabId(): string {
        return this.services.sdk.getCurrentBrowserTabId();
    }

    private get _activeGameTabId(): NullableString {
        return this.services.localStorage.getItem(LocalStorageKeys.currentRunningGameTab);
    }

    private _setActiveGame(gameType: number): void {
        this.services.localStorage.setItem(LocalStorageKeys.currentRunningGameType, gameType);
        this.services.localStorage.setItem(LocalStorageKeys.currentRunningGameTab, this._currentBrowserTabId);
    }

    private _onGameClosed(): void {
        if(!this.isGameRunningInAnotherTab) {
            // On game close we clear local storage only if the closed game was in the current tab otherwise
            // we might also kill the game that was just opened in another tab
            this.services.localStorage.removeItem(LocalStorageKeys.currentRunningGameType);
            this.services.localStorage.removeItem(LocalStorageKeys.currentRunningGameTab);
        }
    }


    get activeGame(): GameInfo | null {
        const gameType = parseInt(this.services.localStorage.getItem(LocalStorageKeys.currentRunningGameType));
        if(Check.isNumber(gameType)) {
            return this.services.games.gamesMap[gameType];
        }

        return null;
    }
}